import setAuthToken from "../config/setAuthToken";
import { _auth } from "./_auth";

const { postRequest, getRequest } = require("./ApiRequest");

export const Projects = {
  profile() {
    return _auth.getUserProfile();
  },

  async create(data) {
    console.log("Call API and pass data", data);
    let profile = this.profile();
    let token = localStorage.getItem("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body", data);
    let response = await postRequest("projects/create", data);
    if (response) {
      console.log("Create project got response");
      return response.data.data;
    } else {
      return response;
    }
  },
  async list() {
    let data = {};
    console.log("Call API and pass data", data);
    let profile = this.profile();
    let token = localStorage.getItem("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body - list projects", data);
    let response = await postRequest("projects/get-projects", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
};
